import React, { Component } from 'react';
import {connect} from 'react-redux'
import selecionarRepasse from '../../actions/repasse-venda/selecionarRepasseVenda';
import { abaRepasseVenda } from '../../util/constantsUtil';
import {withRouter} from 'react-router-dom';

export class AcaoRepasseVenda extends Component {

    render() {
        return (
            <div className="dropdown">
                <span className="titulo-mobile">Ações:</span>
                <button className="btn btn-link btn-acoes btn-sm dropdown" type="button"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i className="material-icons">
                        &#xe5d4;
                    </i>
                </button>
                <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                {this.props.aba === abaRepasseVenda.historicoRepasse ? 
                    <a className="dropdown-item" data-toggle="modal" data-target="#modalRepasseVenda"
                    onClick={() => this.props.selecionarRepasse(this.props.repasseSelecionado)}> 
                        Alterar comprovante
                    </a>
                : ''}
                    <a className="dropdown-item" data-toggle="modal" data-target="#"> 
                        Notificar pagamento
                    </a>
                    
                    <a className="dropdown-item" data-toggle="modal" data-target="#"
                    onClick={() => {                        
                        this.props.selecionarRepasse(this.props.repasseSelecionado);
                        this.props.history.push('/painel-lista-reservas-repasse');
                    }}> 
                        Exibir reservas do repasse
                    </a>

                    {this.props.aba != abaRepasseVenda.historicoRepasse ? 
                    <a className="dropdown-item" data-toggle="modal" data-target="#modalRepasseVenda" 
                    onClick={() => this.props.selecionarRepasse(this.props.repasseSelecionado)}>      
                        Repassar
                    </a> : ''}
                </div>
            </div>
        )
    }
}

export const mapStateToProps = () => {
    return{}};


export default withRouter(connect(mapStateToProps, {
    selecionarRepasse
})(AcaoRepasseVenda))